import React from 'react';
import PropTypes from 'prop-types';

import { getProviderPlanPriceText } from 'common/utility/helpers';

import { formatPrice, numberWithCommas } from 'common/formatters';

import SrMarkdown, { SR_MARKDOWN_THEME_UTILITY_PROFIT } from 'client/components/SrMarkdown';
import SrText from 'client/components/SrText';
import SrExternalLink from 'client/components/SrExternalLink';

import './SrUtilityProfitAmenityConfirmationPlanCard.less';

const SrUtilityProfitAmenityConfirmationPlanCard = ({
  onClick,
  utilityProviderPlan,
  utilityProvider,
}) => {
  if (!utilityProviderPlan) {
    return null;
  }

  const PromotionComponent = utilityProviderPlan.termsOfServiceUrl ? SrExternalLink : SrText;

  return (
    <div styleName="amenityConfirmationPlanCard" onClick={onClick}>
      {utilityProvider && (
        <div styleName="providerBox">
          <div styleName="providerLogoBox">
            <div
              styleName="providerLogo"
              style={{ backgroundImage: `url(${utilityProvider.logoUrl})` }}
            />
          </div>
          <div styleName="providerDetailsBox">
            <div styleName="providerPlanNameText">{utilityProviderPlan.title}</div>
            {utilityProviderPlan.internetSpeedMbps && (
              <div styleName="providerSpeedText">
                {`Speeds up to ${numberWithCommas(utilityProviderPlan.internetSpeedMbps)} Mbps`}
              </div>
            )}
          </div>
        </div>
      )}
      <div styleName="detailsBox">
        <div styleName="discountBox">
          <span styleName="discountIcon">🏷️</span>
          <span styleName="discountText">Exclusive discount&nbsp;</span>
          <span styleName="discountFromText">from your landlord</span>
        </div>
        <div styleName="pricingInfo">
          <div styleName="discountPrice">
            <span styleName="priceCurrent">
              {getProviderPlanPriceText({
                price: utilityProviderPlan.price,
                unit: utilityProviderPlan.priceUnit,
              })}{' '}
              for you.
            </span>
          </div>
          <div styleName="retailPrice">
            <span styleName="priceOriginal">{formatPrice(utilityProviderPlan.originalPrice)}</span>
            <span styleName="priceUnit">
              {utilityProviderPlan.priceUnit ? `/${utilityProviderPlan.priceUnit} ` : ''}
              retail price.
            </span>
          </div>
        </div>
        {utilityProviderPlan.description && (
          <div styleName="descriptionBox">
            <SrMarkdown
              source={utilityProviderPlan.description}
              theme={SR_MARKDOWN_THEME_UTILITY_PROFIT}
            />
            {utilityProviderPlan.broadbandLabelUrl && (
              <div className="SrMarkdown utilityProfit" styleName="broadbandLabelBox">
                <ul>
                  <li
                    onClick={() => {
                      global.open(utilityProviderPlan.broadbandLabelUrl, '_blank');
                    }}
                  >
                    <a>View Broadband Fact Label</a>
                  </li>
                </ul>
              </div>
            )}
            {!utilityProviderPlan.broadbandLabelUrl && (
              <div className="SrMarkdown utilityProfit" styleName="broadbandLabelBox">
                <ul>
                  <li>Broadband Fact Label available before your card is charged</li>
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
      {utilityProviderPlan.promotion && (
        <div styleName="promotionBox">
          <div styleName="promotionText">{utilityProviderPlan.promotion}</div>
          {utilityProviderPlan.termsOfServiceUrl && (
            <PromotionComponent styleName="smallText" link={utilityProviderPlan.termsOfServiceUrl}>
              See offer details
            </PromotionComponent>
          )}
        </div>
      )}
    </div>
  );
};

SrUtilityProfitAmenityConfirmationPlanCard.propTypes = {
  onClick: PropTypes.func,
  utilityProviderPlan: PropTypes.object.isRequired,
  utilityProvider: PropTypes.object.isRequired,
};

SrUtilityProfitAmenityConfirmationPlanCard.displayName =
  'SrUtilityProfitAmenityConfirmationPlanCard';
export default SrUtilityProfitAmenityConfirmationPlanCard;
